import React from 'react';
import TransformSection from './common/transform-section';
import { registerInspector } from './inspector-registry';
import InspectorRow from './shared/inspector-row';
import InspectorSection from './shared/inspector-section';
import NumberField from './shared/number-field';
import { useCommonFabricProp } from './shared/use-common-fabric-prop';
import type { ObjectInspectorProps } from './types';

const MIXED = '(разное)';

const ImageInspector: React.FC<ObjectInspectorProps> = ({ objects, editor }) => {
  const scaleX = useCommonFabricProp<number>(objects, 'scaleX', editor);
  const scaleY = useCommonFabricProp<number>(objects, 'scaleY', editor);
  const opacity = useCommonFabricProp<number>(objects, 'opacity', editor);

  return (
    <>
      <TransformSection objects={objects} editor={editor} />
      <InspectorSection title="Внешний вид">
        <InspectorRow label="Масштаб X">
          <NumberField
            value={scaleX.isMixed ? undefined : scaleX.value}
            onChange={scaleX.setValue}
            step={0.05}
            min={0.01}
            placeholder={scaleX.isMixed ? MIXED : undefined}
          />
        </InspectorRow>
        <InspectorRow label="Масштаб Y">
          <NumberField
            value={scaleY.isMixed ? undefined : scaleY.value}
            onChange={scaleY.setValue}
            step={0.05}
            min={0.01}
            placeholder={scaleY.isMixed ? MIXED : undefined}
          />
        </InspectorRow>
        <InspectorRow label="Прозрачность">
          <NumberField
            value={opacity.isMixed ? undefined : opacity.value}
            onChange={opacity.setValue}
            step={0.05}
            min={0}
            max={1}
            placeholder={opacity.isMixed ? MIXED : undefined}
          />
        </InspectorRow>
      </InspectorSection>
    </>
  );
};

export default ImageInspector;

registerInspector('image', ImageInspector);
